import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import CreateGroupModal from './CreateGroupModal';
import {
  createGroupClear,
  createGroupInitiate,
  getGroupDetailsInitiate,
  setUploadMsg,
} from '../../../../actions/groups';
import { openErrorToast } from '../../../../reducers/uiLogic';
import { currentFlowTypeEnum, groupUploadMsg } from '../constants';

const mapStateToProps = state => {
  const groupData = _get(state, 'groups.groupData', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    groupData,
    selectedWorkspace,
    uploadMsg: _get(state, 'groups.uploadMsg', groupUploadMsg),
    creatingGroup:
      _get(state, 'apiState.CREATE_GROUP.isFetching', false) &&
      !_get(state, 'apiState.CREATE_GROUP.isIdle', false),
    groupCreated:
      _get(state, 'apiState.CREATE_GROUP.success', false) &&
      !_get(state, 'apiState.CREATE_GROUP.isIdle', false),
    fetchingGroupDetails:
      _get(state, 'apiState.GET_GROUP_DETAILS.isFetching', true) &&
      !_get(state, 'apiState.GET_GROUP_DETAILS.isIdle', false),
    processId: _get(state, 'groups.processId', ''),
  };
};

const mapDispatchToProps = dispatch => ({
  clearCreateGroup: () => dispatch(createGroupClear()),
  getGroupDetails: payload => dispatch(getGroupDetailsInitiate(payload)),
  setFileUploadMsg: message => dispatch(setUploadMsg(message)),
  createGroup: payload => dispatch(createGroupInitiate(payload)),
  showErrorToast: message => dispatch(openErrorToast(message)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateGroupModal);
